import { useTheme } from '@mui/material/styles';
export const useStyles = () => {
    const theme = useTheme();
    return {
        loadingIndicator: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            marginTop: theme.spacing(2),
            width: '100%',
        },
        contact: {
            display: 'flex',
            flexDirection: 'column',
        },
        address: {
            display: 'flex',
            justifyContent: 'space-between',
        },
        paymentWrapper: {
            overflowY: 'hidden',
        },
        hidden: {
            display: 'none',
        },
        paymentHeader: {
            marginBottom: theme.spacing(1),
            fontWeight: 'bold',
        },
        zipCode: {
            marginRight: theme.spacing(1),
            width: theme.spacing(15),
        },
        paymentItem: {
            marginTop: theme.spacing(0.5),
            marginBottom: theme.spacing(0.5),
        },
        street: {
            display: 'flex',
            flexGrow: 1,
            '& > *': {
                flexGrow: 1,
            },
        },
        header: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
        },
        b2b: {
            textDecoration: 'underline',
            padding: 0,
            '&:hover': {
                backgroundColor: 'transparent',
                textDecoration: 'underline',
                color: theme.palette.primary.dark,
            },
        },
    };
};
